const KEY = 'inn_pending_envio';
const VALIDADE_MS = 2 * 60 * 60 * 1000;

export const savePending = (data) => {
  try { sessionStorage.setItem(KEY, JSON.stringify({ ...data, at: Date.now() })); } catch { /* noop */ }
};

export const readPending = () => {
  try {
    const p = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!p || Date.now() - p.at > VALIDADE_MS) return null;
    return p;
  } catch { return null; }
};

export const clearPending = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* noop */ }
};
